import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import Button from 'components/ui/Button';
import Api from 'api/Api';
import swal from 'sweetalert';
import { useDispatch } from 'react-redux';
import { setTermList } from 'features/mainSlice';

const SearchTerminal = () => {
  const dispatch = useDispatch();
  const [idTerminal, setIdTerminal] = useState('');
  const [name, setName] = useState('');
  const [hourWork, setHourWork] = useState('');
  const [idKkm, setIdKkm] = useState('');
  const [buildNum, setBuildNum] = useState('');

  //поиск теремов
  const searchTerm = () => {
    //начинать поиск только если введен id терминала или имя+какая-то часть адреса
    let start =
      idTerminal !== 0 || (name !== '' && (hourWork !== '' || buildNum !== ''));

    if (start) {
      Api.getTerm(
        JSON.stringify({
          IDTerminal: Number(idTerminal),
          Name: name,
          HourWork: hourWork,
          Buildnum: buildNum,
          IdKkm: idKkm,
        })
      )
        .then((response) => {
          dispatch(setTermList(response));
        })
        .catch();
    } else {
      swal('Ошибка!', 'Заполните ID теминала или Название и Адрес ', 'error');
    }
  };

  return (
    <div style={{ margin: 0 }}>
      <div className="grid1fr6">
        <div className="customInp customInpT">
          <TextField
            type="number"
            value={idTerminal}
            name="idTerminal"
            onInput={(e) => setIdTerminal(e.target.value)}
            label="Номер терминала"
            variant="filled"
          />
        </div>
        <div className="lineHeight3 contentCenter">
          <b>или</b>
        </div>
        <div className="customInp customInpT">
          <TextField
            type="text"
            value={idKkm}
            name="idKkm"
            onInput={(e) => setIdKkm(e.target.value)}
            label="ID KKM"
            variant="filled"
          />
        </div>
        <div className="customInp customInpT">
          <TextField
            type="text"
            value={name}
            name="name"
            onInput={(e) => setName(e.target.value)}
            label="Имя терминала"
            variant="filled"
          />
        </div>
        <div className="customInp customInpT">
          <TextField
            type="text"
            value={hourWork}
            name="hourWork"
            onInput={(e) => setHourWork(e.target.value)}
            label="Улица"
            variant="filled"
          />
        </div>
        <div className="customInp customInpT">
          <TextField
            type="text"
            value={buildNum}
            name="buildNum"
            onInput={(e) => setBuildNum(e.target.value)}
            label="Дом"
            variant="filled"
          />
        </div>
        <Button color="primary" onClick={searchTerm} className="noMarg ">
          Найти
        </Button>
      </div>
    </div>
  );
};

export default SearchTerminal;
